import { useQuery } from '@tanstack/react-query';
import type { AppointmentEntity } from '@web-app/db';
import { useApiClient } from '@web-app/hooks/useApiClient';

/** A status-less local appointment is the record created when a session starts. */
export const useExistingSessionStarted = (roomId: string) => {
  const apiClient = useApiClient();

  return useQuery({
    queryKey: ['existingSessionStarted', roomId],
    enabled: Boolean(roomId),
    queryFn: async (): Promise<boolean> => {
      const response = await apiClient.get<AppointmentEntity | null>(
        `/appointments/${roomId}`,
      );
      return response.data?.status === null;
    },
    staleTime: Infinity,
    refetchOnMount: 'always',
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    retry: false,
  });
};
